import React, {
  lazy, Suspense,
} from 'react';
import { environment } from '../environments/environment';
import { AvailabilityStatus } from '@nxplatform/spa-service/services/base-window-setup.service';
import { useApplicationBootHook } from '@nxplatform/spa-service/services/application-boot.hook';
import { BlockedPage } from '@nxplatform/spa-service/pages/blocked.page';



const MobileModule = lazy(() => import('./modules/mobile.module'));
const DesktopModule = lazy(() => import('./modules/desktop.module'));

const pageStatusToRender = [AvailabilityStatus.ok, AvailabilityStatus.notFound];


export function App() {
  const { config } = useApplicationBootHook(environment);
  const { data } = config || {};

  return (
    <Suspense fallback={null}>
      {config
        && (
        <>
          {pageStatusToRender.includes(config.status)
            && (
            <>
              {window.isMobile
                && (
                  <MobileModule />
                )}
              {!window.isMobile
                && (
                  <DesktopModule />
                )}
            </>
            )}
          {config.status === AvailabilityStatus.blocked
            && <BlockedPage payload={config.payload} />}
          {config.status === AvailabilityStatus.maintenance
            && <BlockedPage payload={config.payload} />}
        </>
        )}
    </Suspense>
  );
}

export default App;
